export const permissionsKeys = {
  page: 'content-management.institutional-programs',
  pageBlockFind: 'content-management.institutional-programs.find',
  pageBlockCreate: 'content-management.institutional-programs.create',
  pageBlockUpdate: 'content-management.institutional-programs.update',
  pageBlockRemove: 'content-management.institutional-programs.remove',
  pageBlockUpdatePublish: 'content-management.publish.institutional-programs.update',
  pageBlockUpdateStatusToDraft: 'content-management.institutional-programs.updateStatusToDraft',
  pageBlockUpdateInactivate: 'content-management.inactivate.institutional-programs.update',
} as const;
